export const space = ['3xs', '2xs', 'xs', 'sm', 'md', 'base', 'lg', 'xl', '2xl', '3xl', 'none'];
export const isSpace = (x) => {
    const value = x.startsWith('-') ? x.slice(1, x.length) : x;
    return space.includes(value);
};
